import Layout from '@/components/layout/Layout.vue'
import { getAdvertiserAnchors, pullAnchor } from '@/api/advertiser'
import CreateAnchorForm from '@/views/sys/advertiser/anchor/create/Create.vue'

export default {
    components: {
        Layout,
        CreateAnchorForm,
    },
    props: {
        showAnchorForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            data: [],
            pagination: { defaultPageSize: 20 },
            loading: false,
            columns: [
                { title: '锚点ID', dataIndex: 'anchor_id' },
                { title: '类型', dataIndex: 'type_name' },
                { title: '锚点名称', dataIndex: 'name' },
                { title: '来源', dataIndex: 'source_name' },
                { title: '审核状态', dataIndex: 'status', scopedSlots: { customRender: 'status' } },
                { title: '创建时间', dataIndex: 'create_time' },
            ],
            queryParam: {},
            showCreateForm: false,
            anchorModel: {},
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        handleTableChange(pagination) {
            const pager = { ...this.pagination }
            pager.current = pagination.current
            this.pagination = pager
            this.getData()
        },
        getData() {
            this.loading = true
            const pagination = { ...this.pagination }
            const json = Object.assign({}, this.queryParam, {
                page: pagination.current,
                page_size: pagination.defaultPageSize,
                id: this.model.id,
            })
            this.$helper.buildDateRangeParams(json, 'date')
            getAdvertiserAnchors(json).then(res => {
                pagination.total = res.data.total
                this.loading = false
                this.data = res.data.list
                this.pagination = pagination
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            this.pagination.current = 1
            this.getData()
        },
        close() {
            this.$emit('update:showAnchorForm', false)
        },
        resetSearch() {
            this.queryParam = {}
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('AdvertiserController', route)
        },
        pullData() {
            const json = {
                ids: [this.model.id],
            }
            // console.log('点击了手动拉取锚点按钮', json)
            pullAnchor(json).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('拉取成功')
                    this.pagination.current = 1
                    this.getData()
                } else {
                    this.$message.error('拉取失败')
                }
            }).catch(() => {
                this.$message.error('拉取失败')
            })
        },
        createAnchor() {
            //过滤没有资产的广告主
            if (!this.model.juliang_apps || this.model.juliang_apps.length<1) {
                return this.$message.error('请先创建小程序资产！')
            }
            this.anchorModel = {
                anchor_type: 'APP_INTERNET_SERVICE', //样式:网服
                net_service_type: 'MICRO_APP', //推广内容：微信小程序
                ios_anchor_title: null,
                android_anchor_title: null,
                app_description: null, //APP详情
                app_tags: [null,null,null],
                guide_text: null,
                advertisers: [
                    { advertiser_id: this.model.id, out_id: this.model.out_id, advertiser_name: this.model.name, apps: this.model.juliang_apps ? this.model.juliang_apps : []}
                ],
            }
            this.showCreateForm = true
        },

    }
}
